"use client";

import { X } from "lucide-react";

/**
 * A small × that removes a destination or home city from the comparison. It shows on hover or
 * focus of the surrounding `group/place`, and always on touch screens.
 * @param props.name - The place, for the label ("Remove Phoenix").
 * @param props.onRemove - Removes it.
 * @returns The button.
 * @throws Never.
 */
export const RemovePlaceButton = ({ name, onRemove }: { name: string; onRemove: () => void }) => (
  // ui-lint-disable-next-line raw-control: a custom control (segment, chip, calendar day, stepper, icon or inline editor) styled to its row; FetchButton's sizes and 3D treatment don't fit
  <button
    type="button"
    aria-label={`Remove ${name}`}
    title={`Remove ${name}`}
    onClick={(event) => {
      event.stopPropagation();
      onRemove();
    }}
    className="relative after:absolute after:-inset-2.5 after:content-[''] flex size-6 shrink-0 items-center justify-center rounded-md text-gray-400 opacity-0 transition-opacity hover:bg-gray-100 hover:text-gray-900 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 group-hover/place:opacity-100 [@media(hover:none)]:opacity-100"
  >
    <X className="size-3.5" />
  </button>
);
